import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { getModules as onGetModules } from "store/actions";
import { FNOLModuleId, usersModuleID } from "utils/modulesIds";

const ShortcutMenu = () => {
  const [socialDrp, setsocialDrp] = useState(false);

  const dispatch = useDispatch();

  const { modules } = useSelector((state) => ({
    modules: state.Sidebar.modules,
  }));

  // getting all modules when the component did mount
  useEffect(() => {
    if (modules.length === 0) {
      dispatch(onGetModules());
    }
  }, [modules.length]);

  const shortcuts = [FNOLModuleId, usersModuleID];
  return (
    <Dropdown
      className="d-none d-lg-inline-block ms-1"
      isOpen={socialDrp}
      toggle={() => {
        setsocialDrp(!socialDrp);
      }}
    >
      {/* Shortcuts Menu Toggler */}

      <DropdownToggle className="btn header-item noti-icon " tag="button">
        <i className="bx bx-customize" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
        <div className="px-lg-2">
          <Row className="no-gutters">
            {modules.length > 0 &&
              modules.map((module) => (
                <Fragment key={module.id}>
                  {module.sub_modules.length > 0 &&
                    module.sub_modules.map(
                      (sub_module) =>
                        shortcuts.includes(sub_module.id) && (
                          <Col key={sub_module.id}>
                            <Link
                              className="dropdown-icon-item"
                              style={{ width: "140px" }}
                              to={`/${sub_module.name
                                .toLowerCase()
                                .replace(" ", "-")}`}
                            >
                              <i
                                className={`${sub_module.icon} font-size-24`}
                              ></i>
                              <span>{sub_module.title}</span>
                            </Link>
                          </Col>
                        )
                    )}
                </Fragment>
              ))}
          </Row>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ShortcutMenu;
